import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { ReturnLossMutationKeys } from '../../../keys'
import { deleteReturnLoss } from '../../services'

interface UseMutationDeleteReturnLossProps {
	id: string
}

export default function useMutationDeleteReturnLoss(
	props?: UseBaseMutationOptions<void, UseMutationDeleteReturnLossProps>,
) {
	return useMutation({
		mutationKey: [ReturnLossMutationKeys.DeleteReturnLoss],
		mutationFn: ({ id }) => deleteReturnLoss(id),
		...props,
	})
}
